export class LoanConsentsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getApplicationConsents({ applicationId }) {
    return this.#http.get(`/application-consents/${applicationId}`);
  }
}
